(function($, root) {

  $.hideIntro = function() {
    var deferred = $.Deferred();

    $('intro').removeClass('fadeIn').addClass('fadeOut');

    setTimeout(function() {
      $('intro').hide();

      deferred.resolve();
      $.cleanVideo();

    }, window.rdo.transitions.transition);

    return deferred.promise();

  };

  $.showIntro = function() {
    $('intro').show();
    $('intro').removeClass('fadeOut').addClass('fadeIn');
  };

  $.startIntro = function() {
    $(document).unbind('videoover');
    // console.log('starting intro ' + window.rdo.data.page.intro.video);

    var deferred = $.Deferred();
    $('intro').show();
    $.showSpinner();

    // let introVid = 'SjTjsIdciu4';
    var introVid = window.rdo.data.page.intro.video;

    if (introVid) {

      $.renderIntro(introVid);

      $(document).on('videoover', function() {
        // console.log('video over!!!!!');

        if (window.rdo.video.tv) {
          window.rdo.video.tv.stopVideo();
          window.rdo.video.tv = null;
        }

        deferred.resolve();
      });

    } else {
      deferred.resolve();
    }

    return deferred.promise();

  };

  $.loadIntro = function() {

    $.startIntro().done(function() {

      $.hideIntro().done(function() {
        $.initSelections();

        console.log('intro over');
        $('main').show();

        $('body').addClass('show-content');
        $('header').fadeIn();
        window.rdo.loader.introdone = true;

        $.onresizeWithTimeout(function() {
          // $('#vertical-timeline').getInitialScrollPositions('.sitem', '#vertical-timeline .wrapper');
          $.vidRescale();

        });
      });
    });

  };

  $.startPage = function() {
    // if (window.rdo.isMobile) {
    //   $('intro').hide();
    //   console.log('intro over');
    //   $('main').show();
    //   $.initSelections();
    //
    //   $('body').addClass('show-content');
    //   $('header').fadeIn();
    //   window.rdo.loader.introdone = true;
    //
    //   $.onresizeWithTimeout(function() {
    //     // $('#vertical-timeline').getInitialScrollPositions('.sitem', '#vertical-timeline .wrapper');
    //     $.vidRescale();
    //
    //   });
    // } else

    if (window.rdo.type != 'main') {
      $.loadPage();
    } else {
      // console.log('loadIntro@startPage.intro.js');
      $.loadIntro();
    }

  };

  //replay intro:
  $('body').on('click', '#vertical-timeline .intro-button', function() {

    window.rdo.header.shown = false;
    window.rdo.loader.introdone = false;
    $('body').removeClass('show-content');
    $('header').fadeOut();
    $('body').addClass('dark-bg');

    $.cleanVideo();
    $.pauseTimer();
    $.loadIntro();

    $('intro').removeClass('fadeOut').animateCss('fadeIn', function() {
      $('main').html('');
    });

    $.hideMain();

  });

  $('html').on('click', 'intro .buttons button.watch', function() {
    // console.log('play video');
    // console.log(window.rdo.video.tv);

    // if (!window.rdo.isMobile) {
    window.rdo.video.tv.playVideo();
    // if (window.rdo.isMobile) {
    //   $('#tvintro').show();
    //
    // }
    // } else {
    //   //$(document).trigger('videoover');
    // }
  });

  $('html').on('click touchstart', 'intro .buttons button.skip', function() {
    $(document).trigger('videoover');
  });

  $.showStartButton = function() {
    console.log('showing start button');
    $('intro .buttons .watchplay').animateCss('fadeIn', function() {
      $('intro .buttons .watchplay').removeClass('fadeOut');
    });
    // $('intro .buttons .watchplay').removeClass('fadeOut').addClass('fadeIn');
  };

  $.hideStartButton = function() {
    if ($('intro .buttons .watchplay').hasClass('fadeIn')) {
      $('intro .buttons .watchplay').removeClass('fadeIn').animateCss('fadeOut', function() {
        $('intro .buttons .watchplay').removeClass('fadeOut');
      });
    }
  };

})(jQuery, this);
